module.exports = __webpack_public_path__ + "static/media/become-anchor-banner.b23baf13.jpg";